<template>
    <div id="ChoiceCompany" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal content-->
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-building"></i> {{$t('message.choice_company')}}</p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{loginMsg}}</p>
                    <div class="form-group">
                        <required /> <label>{{$t('words.company')}}</label>
                        <select name="company" :class="{ 'is-invalid': errors.has('company') }"
                            v-model="request.companyId" v-validate="{required:true}" class='form-control'>
                            <option :value="null">{{$t('words.select')}}</option>
                            <option v-for="(item, index) in companies" :key="index" :value="item.id">
                                {{item.empresa_nome}}</option>
                        </select>
                        <div class="invalid-feedback help-block error">{{errors.first('company')}}</div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left">
                        <i class="fa fa-times"></i> {{$t('words.cancel')}}
                    </button>
                    <button type="button" @click="logar()" :disabled="loading" class="btn btn-success"><i
                            class="fa fa-check"></i> {{$t('words.access')}}
                        <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            request: {}
        },
        data() {
            return {
                loginMsg: '',
                loading: false,
                companies: []
            }
        },
        methods: {
            show(response) {
                this.loginMsg = response.data.message;
                this.companies = response.data.empresas;
                $('#ChoiceCompany').modal('toggle');
            },
            logar() {
                this.$validator.validateAll(['company']).then(valid => {
                    if (!valid) {
                        return
                    }
                    this.loading = true;
                    this.$auth.logar(this.request).then(response => {
                        $('#ChoiceCompany').modal('toggle');
                        this.$router.push('/inbox');
                    }).catch(error => {
                        if (error.data.two_factory) {
                            $('#ChoiceCompany').modal('toggle');
                            setTimeout(() => {
                                this.$emit('showTwoFactoryModal', error);
                            }, 500)
                            return;
                        }
                        toastr({
                            icon: error.data.status,
                            title: error.data.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    })
                });
            }
        }
    }
</script>